import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, ApiError } from '../api';

type AuthoringList = { canCreate: boolean; courses: { id: number; name: string; code: string | null; status: string; unitCount: number }[] };
export function InstructorCourses() {
  const [data, setData] = useState<AuthoringList | null>(null);
  const [error, setError] = useState('');
  useEffect(() => { void api.get<AuthoringList>('/admin/builder').then(setData).catch(e => setError((e as ApiError).message)); }, []);
  return <>
    <div className="page-head"><h1 className="h1">My teaching courses</h1>{data?.canCreate && <Link className="btn btn--primary" to="/instructor/courses/new">Create a course</Link>}</div>
    <p className="muted">Prepare and maintain the courses you teach. New courses start switched off.</p>
    {error && <p className="auth__error">{error}</p>}
    {!data && !error && <p className="muted">Loading…</p>}
    {data?.courses.length === 0 && <p className="muted">You are not assigned as an instructor to any courses yet.</p>}
    {data && <ul className="builder">{data.courses.map(c => <li className="builder__row" key={c.id}>
      <span className="builder__main"><Link to={`/instructor/courses/${c.id}/edit`}>{c.name}</Link><span className="muted small">{c.code ? c.code + ' · ' : ''}{c.unitCount} units</span></span>
      <span className="tag">{c.status === 'active' ? 'live' : 'switched off'}</span>
    </li>)}</ul>}
  </>;
}
